import React from 'react'
import { Grid, Typography } from '@mui/material'
import PickUp from 'components/pickAndDrop/PickUp';
import meter from 'assets/images/meter.svg'
import car from 'assets/images/CarProfile.svg'
import rideTrackError from 'assets/images/tripErrorImg.svg'
import profile from "assets/images/ProfileVendor.svg";


const calculateGSTAmount = (tripDetails) => {
  if (tripDetails) {
    const gstBreakdown = tripDetails.breakdown?.find(item => item.chargeType === 'gst');
    return gstBreakdown?.addedCharge || 0;
  }
  return (tripDetails?.cgstAmount || 0) + (tripDetails?.sgstAmount || 0);
};

function formatPrice(value) {
  if (isNaN(value)) return value;
  return Number(value).toLocaleString('en-IN'); // 'en-IN' → Indian format (e.g., 92,495)
}

const getTripCharges = (tripDetails) => {
  if (!tripDetails) return 0;
  const excludedTypes = ['tollCharges', 'parkingCharge', 'discountAmount', 'gst', 'tip', 'pointsRedeem'];
  const baseAmount = tripDetails.baseRate || 0;
  const rideFee = tripDetails?.baseFareDisplay  || tripDetails?.subtotal - (tripDetails?.baseRate + tripDetails?.surCharge + tripDetails?.platformCharge) || 0;
  const surcharge = tripDetails.surCharge || 0;
  const platformCharge = tripDetails.platformCharge || 0;
  
  const additionalCharges = tripDetails.breakdown
    ?.filter(item => !excludedTypes.includes(item.chargeType))
    ?.reduce((sum, item) => sum + (item.addedCharge || 0), 0) || 0;

  return rideFee + baseAmount + surcharge + platformCharge + additionalCharges;
};

const getBreakdownAmount = (tripDetails, chargeType) => {
  return tripDetails?.breakdown?.find(item => item.chargeType === chargeType)?.addedCharge || 0;
};

function InvoiceMap(props) {
  const tripDetails = props?.tripDetails;
  console.log("tripDetails", tripDetails);

  const handleImgError = (e) => {
    e.target.src = rideTrackError
  }

  const handleDriverImgError = (e) => {
    e.target.src = profile
  }

  const renderChargeSection = (label, amount, subBreakup = null, isNegative = false) => {
    if (!amount || amount <= 0) return null;

    return (
      <Grid item container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        className='marginbottom20'>
        <Grid item>
          <Typography style={{fontSize: '1.25rem', fontWeight: 500}}>{label}</Typography>
          {subBreakup}
        </Grid>
        <Grid item>
          <Typography className={`font14 ${isNegative ? 'colorRed' : ''}`}>
            {isNegative ? `-₹${formatPrice(Math.abs(amount))}` : `₹${formatPrice(amount)}`}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderTripChargesBreakup = () => {
    console.log("props?.type", props?.type);
    const breakupItems = [
      { label: 'Base Rate', value: tripDetails?.baseRate },
      { 
        label: (props?.type == 1 || props?.type == 4) ? 'Total Base Fare' : 'Package Cost',
        value: tripDetails?.baseFareDisplay  || tripDetails?.subtotal - (tripDetails?.baseRate + tripDetails?.surCharge + tripDetails?.platformCharge),
        ratePer: (props?.type == 1 || props?.type == 4) ? {lable: 'Rate per KM', value: tripDetails?.baseRatePerKM} : null
      },
      { label: 'Surcharge', value: tripDetails?.surCharge },
      { label: 'Platform Charge', value: tripDetails?.platformCharge },
      { label: 'Peak Hour Charges', value: getBreakdownAmount(tripDetails, 'peakHour') },
      { label: 'Waiting Charges', value: getBreakdownAmount(tripDetails, 'waitingTimeCharge') },
      { label: 'Cancellation Charges', value: getBreakdownAmount(tripDetails, 'cancellationCharge') },
      { label: 'Extra KM', value: getBreakdownAmount(tripDetails, 'extraKm') },
      { label: 'Extra Hours', value: getBreakdownAmount(tripDetails, 'extraHrs') },
      { label: 'Driver Allowance', value: getBreakdownAmount(tripDetails, 'driverAllowance') },
      { label: 'Night Allowance', value: getBreakdownAmount(tripDetails, 'nightAllowance') },
      { label: 'Aditional Charges', value: getBreakdownAmount(tripDetails, 'additionalCharges') },
      { label: 'Placard Charges', value: getBreakdownAmount(tripDetails, 'placard') },
    ];

    return (
      <>
        {breakupItems
          .filter(item => item.value > 0)
          .map((item, index) => (
            <Typography key={index} className='colorGrey font24 fontSemiBold'>
              {`${item.label}: ₹${formatPrice(item.value)} ${item.ratePer ? `@(${item.ratePer.lable}: ₹${formatPrice(item.ratePer.value)})` : ''}`}
            </Typography>
          ))}
      </>
    );
  };

  return (
    <Grid container direction='column' justifyContent='center' alignItems='start'>

      <Grid container item direction='column' md={12}>
        {/* <Typography className='font24 fontMedium'>Bill Details</Typography> */}
        <Grid container item direction='column' justifyContent='space-between' 
          alignItems='center' md={12}>

          {/* Main Charges Sections */}
          {renderChargeSection('Trip Charges', getTripCharges(tripDetails), renderTripChargesBreakup())}

          {/* Points Redeemed Section */}
          {renderChargeSection('Coins Redeemed', getBreakdownAmount(tripDetails, 'pointsRedeem'), null, true)}
          
          {renderChargeSection('Discount', 
            Math.abs(getBreakdownAmount(tripDetails, 'discountAmount')), null, true)}
          
          {renderChargeSection('GST', calculateGSTAmount(tripDetails),
            tripDetails?.breakdown?.find(item => item.chargeType === 'gst')?.meta?.breakup?.map((tax, idx) => (
              <Typography key={idx} className='colorGrey font12'>
                {`${tax.name.toUpperCase()}: ${tax.unitValue}% (₹${tax.totalCharge})`}
              </Typography>
            ))
          )}

          {renderChargeSection('Tolls & Parking', 
            (getBreakdownAmount(tripDetails, 'tollCharges') + getBreakdownAmount(tripDetails, 'parkingCharge')))}
          
          {renderChargeSection('Tip', getBreakdownAmount(tripDetails, 'tip'))}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default InvoiceMap;